import React from "react";
import {
    Popover,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    Box,
    Typography,
    Avatar
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { allSearchItems } from "../../../data";

type SearchPopoverProps = {
    anchorEl: null | HTMLElement;
    open: boolean;
    handleClose: () => void;
    query: string;
    popoverId?: string;
};

const SearchPopover: React.FC<SearchPopoverProps> = ({ anchorEl, open, handleClose, query,popoverId}) => {
    const navigate = useNavigate();

    const filtered = query
        ? allSearchItems.filter(item =>
            item.label.toLowerCase().includes(query.toLowerCase()) ||
            item.category.toLowerCase().includes(query.toLowerCase())
        )
        : [];

    const limitedResults = filtered.slice(0, 5);

    const handleSelect = (link: string) => {
        handleClose();
        setTimeout(() => navigate(link), 0);
    };

    return (
        <Popover
            id={popoverId}
            open={open && !!query}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            disableAutoFocus
            disableEnforceFocus
            disableRestoreFocus
            PaperProps={{
                sx: {
                    minWidth: 340,
                    maxWidth: 340,
                    width: 340
                }
            }}
        >
            <Box sx={{ p: 2, minWidth: 340, maxWidth: 340 }}>
                <List
                    dense
                    sx={{
                        maxHeight: 290,
                        minHeight: 50,
                        overflowY: "auto"
                    }}
                >
                    {query && !limitedResults.length && (
                        <ListItem>
                            <ListItemText primary="Aucun résultat" />
                        </ListItem>
                    )}
                    {limitedResults.map(item => (
                        <ListItem key={item.label + item.link} disablePadding>
                            <ListItemButton
                                onClick={() => handleSelect(item.link)}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: item.color + "22",
                                    },
                                    borderRadius: 1,
                                    mb: 0.5
                                }}
                            >
                                <Avatar
                                    sx={{
                                        bgcolor: item.color,
                                        width: 32,
                                        height: 32,
                                        mr: 2
                                    }}
                                >
                                    <FontAwesomeIcon icon={item.icon} color="white" />
                                </Avatar>
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        {item.label}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {item.category}
                                    </Typography>
                                </Box>
                            </ListItemButton>
                        </ListItem>
                    ))}
                    {filtered.length > 5 && (
                        <ListItem>
                            <ListItemText
                                primary="(5 premiers résultats affichés)"
                                primaryTypographyProps={{ color: "primary" }}
                            />
                        </ListItem>
                    )}
                </List>
            </Box>
        </Popover>
    );
};

export default SearchPopover;